import React, { forwardRef } from "react";
import MaterialTable from 'material-table';
import { Formik } from 'formik'
import TextField from '@material-ui/core/TextField'
import { updateMeasure, deleteMeasure, cat_fibtexFromServer, getMeasuresById } from './firebase';
import * as XLSX from 'xlsx';

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import Export from '@material-ui/icons/CloudDownload'

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
  };

export default function EditTable(props) {
    //console.log('user => '+props.user.email)
    const [yearHuella, setYearHuella] = React.useState(props.year);
    const [openEdit, setOpenEdit] = React.useState(false);
    const [measureEdit, setMeasureEdit] = React.useState([])
    const [idUpdate, setIdUpdate] = React.useState()

    var [state, setState] = React.useState({
        columns: [
            { title: 'ID', field: 'id', editable: false, hidden: true},
            { title: 'Usuario', field: 'usuario', editable: false,  hidden: true},
            { title: 'Pasajeros', field: 'pasajeros', editable: false,  hidden: true},
            { title: 'Fecha', field: 'fecha', editable: false,  hidden: true},
            { title: 'Año', field: 'year', editable: false,  hidden: true},
            { title: 'FE', field:'fe', hidden: true},
            { title: 'Alcance', field: 'alcance'},
            { title: 'Categoría', field: 'categoria', hidden: true},
            { title: 'Subcategoría', field: 'subcategoria', editable: false },
            { title: 'Nombre', field: 'nombre'},
            { title: 'Trayecto ó Ubicación', field: 'trayecto' },
            { title: 'Referencia', field: 'referencia'},
            { title: 'Distancia(km) ó Consumo energía anual ', field: 'distancia'},
            { title: 'Resultado (Kg CO2eq)', editable: false, field: 'resultado'}
            
        ],
    });

    const [isLoading,setIsLoading] = React.useState(true);
    //console.log('...Se escucho 👀 cambioS...')
    
    React.useEffect(() => {
        // By moving this function inside the effect, we can clearly see the values it uses.
        setIsLoading(true);
        async function fetchMeasures() {
            setIsLoading(false);
        }
        fetchMeasures();
    }, []);

    const callHomeRefrescar =() =>{
        props.parentCallback(true);
    }

    const handleDelete = async (id)=>  {
        const borrado = await deleteMeasure(id);
        console.log('¿SI borró?' +borrado);
        if (borrado) {
            callHomeRefrescar();
        }else{
            alert('Ocurrio una novedad en el borrado!');
        }
    }

    const handleEdit = async (id) => {
        setIdUpdate(id);
        const measureRef = await getMeasuresById(id);
        console.log(measureRef);
        setMeasureEdit(measureRef);
        setOpenEdit(true);
    }

    const handleChanges=(event)=>{
        const {name, value} = event.target
        if (name === 'year' ) { 
            setMeasureEdit({
                ...measureEdit,
                [name]: Number(value),
            });    
        }else{
            setMeasureEdit({
                ...measureEdit,
                [name]: value,
            });
        }
        console.log('name = '+ name +' value= '+value);
    }

    const actualizarResultado=()=> {
        // console.log('Props.user = '+props.user.email);
        // console.log('Measure fe = '+measureEdit.fe);
        // console.log('Categoria == '+ measureEdit.categoria)
        measureEdit.user = props.user.email;
        if (measureEdit.categoria === 'Consumo de energía' || measureEdit.categoria === 'Consumo de energía eléctrica') {
            if (measureEdit.referencia_producto.includes('Factura')) {
                measureEdit.resultado_kgco2 = measureEdit.consumo_energia_anual_kwh * measureEdit.fe
                //console.log(measureEdit.resultado_kgco2)
            }else{
                measureEdit.tiempo_horas_year = measureEdit.horas_dia * measureEdit.dias_year;
                measureEdit.consumo_energia_anual_kwh = measureEdit.tiempo_horas_year * measureEdit.cantidad_dispositivos * measureEdit.consumo_energia_hora_kwh;
                measureEdit.consumo_energia_anual_mwh = measureEdit.consumo_energia_anual_kwh / 1000;
                measureEdit.resultado_kgco2 = measureEdit.consumo_energia_anual_kwh * measureEdit.fe;
                // console.log(measureEdit.horas_dia+' -- '+measureEdit.dias_year)
                // console.log(measureEdit.tiempo_horas_year+' -- '+measureEdit.consumo_energia_anual_mwh+' -- '+measureEdit.fe)
            }
        }else{
            let peso = Number(measureEdit.peso_ton); if (peso === 0) { peso = 1 }
            let distancia = Number(measureEdit.distancia_km); if (distancia === 0) { peso = 1 }
            //let numRecorridos = measureEdit.numero_recorridos; if(numRecorridos === 0) {numRecorridos = 1}
            if (measureEdit.referencia_producto === 'personal') {
                measureEdit.resultado_kgco2 = distancia * measureEdit.fe / 1000;
            }else{
                measureEdit.resultado_kgco2 = measureEdit.distancia_km * Number(measureEdit.fe) * peso / 1000;
            }
            console.log(distancia +' -- '+ measureEdit.fe +' -- '+ peso)
        }
        
        console.log('Enviando a guardar: Measure to guardar ='+JSON.stringify(measureEdit, null, 2));
    }

    const handleGuardar = async (event)=> {
        event.preventDefault();
        actualizarResultado();
        
        const guardado = await updateMeasure(measureEdit, idUpdate);
        console.log('guardado ='+guardado);
        console.log('Nuevo resultado = '+measureEdit.resultado_kgco2);
        setOpenEdit(false);
        props.parentCallback(true);
    }
    const alcances = [{nombre:1},{nombre:2},{nombre:3}]
    const tipoTransporte = [{id:'1',nombre:'Personal'},{id:'2',nombre:'Carga'}]
    
    const nombreSubcatFibtex = [{id: 1, nombre:'Transporte producto final'},
                                {id: 2, nombre:'Transporte materia prima'},
                                {id: 3, nombre:'Transporte trabajo'},
                                {id: 4, nombre:'Planta'},
                                {id: 5, nombre:'Oficinas'}
                                ]

    const subcatFibtex = [{id: 1,nombre: "Transporte terrestre",},
                        {id: 2,  nombre: "Transporte aéreo"},
                        {id: 3,  nombre: "Transporte marítima"},
                        {id: 4,  nombre: "Consumo de energía"}] 
    
    const exportExcel=()=>{
        let newData = props.data.map(row=>{
            //delete row.tableData
            delete row.fe
            return row
        })

        const workSheet=XLSX.utils.json_to_sheet(newData)
        const workBook=XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workBook, workSheet,"datos")
        //Buffer
        let buf=XLSX.write(workBook,{bookType:"xlsx",type:"buffer"})
        //Binary string
        XLSX.write(workBook,{bookType:"xlsx",type:"binary"})
        //Download file
        XLSX.writeFile(workBook,"huella_carbono.xlsx")
        
    }
    return (
        <div>
        { openEdit &&
            <div className="edit__measure">
                <h2>Edición de entrada </h2>
                <Formik>
                    { /*TODO*/ }

                    <form onSubmit={handleGuardar}>
                        <button className="guardar__edicion__boton" type="submit">Guardar edición</button>
                        <div className="list__campos__measure">
                        {
                            Object.entries(measureEdit).map(([key, value]) => 
                                {
                                    if (key==='categoria' || key === 'subcategoria') {
                                    return  <TextField
                                        id="outlined-disabled"
                                        inputProps={{style: {fontSize: 19,readOnly: true}}} // font size of input text
                                        InputLabelProps={{style: {fontSize: 20}}} // font size of input label
                                        style={{padding:'5px 10px 5px 10px'}}
                                        name={key}
                                        key={key} 
                                        value={value}
                                        disabled
                                        onInput={handleChanges} 
                                        label={key.replace(new RegExp('_', 'g'), ' ')}/>
                                    }else
                                    if (key === 'empresa' || key === 'fe' || key === 'resultado_kgco2' || key === 'resultado_gco2' || key === 'resultado_tco2' || key === 'user') {
                                        return null
                                    } else if (key==='nombre') {
                                    return <div key='100' style={{padding:'5px 10px 5px 10px'}}>
                                        <label htmlFor="email" style={{ display: "block" }}>
                                            Nombre
                                        </label>
                                        <select name={key} value={value} onChange={handleChanges} >
                                            <option key='0' value={value} label={value}>{value}</option>
                                            {nombreSubcatFibtex.map((nom) => {
                                                return <option key={nom.id} value={nom.nombre} label={nom.nombre}>{nom.nombre}</option>   
                                            })}
                                        </select>
                                    </div>
                                    }else if (key==='alcance') {
                                    return <div key='200' style={{padding:'5px 10px 5px 10px'}}>
                                                <label htmlFor="email" style={{ display: "block" }}>
                                                    Alcance
                                                </label>
                                                <select name={key} value={value} onChange={handleChanges} >
                                                    <option key='10' value={value} label={value}>{value}</option>
                                                    {alcances.map((alc) => {
                                                        return <option key={alc.nombre} value={alc.nombre} label={alc.nombre}>{alc.nombre}</option>   
                                                    })}
                                                </select>
                                            </div>
                                    }else if (key==='tipo_transporteAereo' && measureEdit.subcategoria === 'Transporte aéreo') {
                                    return <div key='400' style={{padding:'5px 10px 5px 10px'}}>
                                                <label htmlFor="email" style={{ display: "block" }}>
                                                    Referencia o producto
                                                </label>
                                                <select name={key} value={value} onChange={handleChanges} >
                                                    <option key='10' value={value} label={value}>{value}</option>
                                                    {tipoTransporte.map((sub) => {
                                                        return <option key={sub.nombre} value={sub.nombre} label={sub.nombre}>{sub.nombre}</option>   
                                                    })}
                                                </select>
                                            </div>
                                    } else {

                                    return <TextField 
                                                inputProps={{style: {fontSize: 19}}} // font size of input text
                                                InputLabelProps={{style: {fontSize: 20}}} // font size of input label
                                                style={{padding:'5px 10px 5px 10px'}}
                                                name={key}
                                                key={key} 
                                                value={value} 
                                                onInput={handleChanges} 
                                                label={key.replace(new RegExp('_', 'g'), ' ')}/>
                                    }}
                            )
                        }
                        </div>
                    </form>
                </Formik>
                <button className="cancelar__edicion__boton" 
                        onClick={() => setOpenEdit(false)}
                >Cancelar edición</button>
            </div>    
        }
        { !isLoading &&
        
            <MaterialTable
                title="Entradas por cada subcategoría "
                columns={state.columns}
                data={(props.data)}
                icons={tableIcons}
                isLoading={isLoading}
                actions={[
                    {
                        icon:Edit,
                        tooltip: 'Editar entrada',
                        onClick: (event, rowData) =>{
                            handleEdit(rowData.id);
                        }
                    },{
                        icon:Export,
                        tooltip:"Exportat a Excel",
                        onClick:()=>exportExcel(),
                        isFreeAction:true
                    }
                ]}
                editable={{
                    onRowDelete: (rowDelete) => new Promise((resolve, reject) => {
                        setTimeout(() => {
                            handleDelete(rowDelete.id)
                            resolve();
                        }, 2000)
                    }),
                    onRowAddCancelled: rowData => console.log('Row adding cancelled'),
                    onRowUpdateCancelled: rowData => console.log('Row editing cancelled'),
        
                }}
                localization={{ body: { editRow: { deleteText: '¿Realmente desea borrar este registro?' } }, 
                                header: { actions: 'Acciones' }
                }}
                /*options={{
                    exportButton: true
                }}*/
            />
        }
        </div>
    );
    }